import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=9f9be7de&scoped=true"
import script from "./comment.vue?vue&type=script&lang=js"
export * from "./comment.vue?vue&type=script&lang=js"
import style0 from "./comment.vue?vue&type=style&index=0&id=9f9be7de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9be7de",
  null
  
)

export default component.exports